
export function setToken (token) {
	window.localStorage.setItem('ebtoken', token)
}

export function getToken () {
	return window.localStorage.getItem('ebtoken')
}

export function setRegion (region) {
	window.localStorage.setItem('region', JSON.stringify(region))
}

export function getRegion () {
	return JSON.parse(window.localStorage.getItem('region'))
}
export function setUesrId (id) {
  window.localStorage.setItem('user_id', id)
}

export function getUesrId () {
  return window.localStorage.getItem('user_id')
}

export function setAccount (info) {
  window.localStorage.setItem('eb_user_info', info)
}

export function getAccount () {
  return window.localStorage.getItem('eb_user_info')
}

export function setAccountPhone (info) {
  window.localStorage.setItem('eb_user_info_phone', info)
}

export function getAccountPhone () {
  return window.localStorage.getItem('eb_user_info_phone')
}

export function setAccountPwd (info) {
  window.localStorage.setItem('eb_user_info_pwd', info)
}

export function getAccountPwd () {
  return window.localStorage.getItem('eb_user_info_pwd')
}

export function setAccountType (info) {
  window.localStorage.setItem('eb_user_type', info)
}

export function setAccountTypeName (info) {
  window.localStorage.setItem('eb_user_type_name', info)
}

export function getAccountType () {
  return window.localStorage.getItem('eb_user_type')
}
export function getAccountTypeName () {
  return window.localStorage.getItem('eb_user_type_name')
}

export function setOtaType (info) {
  window.localStorage.setItem('eb_use_ota_type', info)
}

export function getOtaType () {
  var data = window.localStorage.getItem('eb_use_ota_type')
  return data ? window.localStorage.getItem('eb_use_ota_type') + "" : 7 + ""
}

export function setAuxType (info) {
  window.localStorage.setItem('eb_use_aux_type')
}

export function getAuxType () {
  var data = window.localStorage.getItem('eb_use_aux_type')
  return data ? window.localStorage.getItem('eb_use_aux_type') + "" : 1 + ""
}


// WEBPACK FOOTER //
// ./src/utils/localstorage.js